module.exports = __webpack_public_path__ + "static/img/98065A_2_3_R_20200526_LC.5e8e138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98065A_2_3_R_20200526_LC.png
// module id = Hb6Q
// module chunks = 0